async function fetchTradeinItemsCount() {
  const tradeinUuid = localStorage.getItem('tradeinUuid');
  if (tradeinUuid) {
    const tradein = await getTradeinItemsCount(tradeinUuid);
    return Promise.resolve(tradein.tradeinItems.length || null);
  }

  return null;
}
class TradeInCartIconBubble extends HTMLElement {
  constructor() {
    super();
    this.icon_cart = this.querySelector('.icon');
    this.bubble = this.createBubble();
    this.count = this.getAttribute('count') | 0;
  }

  static get observedAttributes() {
    return ['count'];
  }

  createBubble() {
    const bubble = document.createElement('span');
    bubble.classList.add('tradein-cart-icon__bubble', 'bubble');
    this.icon_cart.appendChild(bubble);
    return bubble;
  }

  async fetchItemsCount() {
    const count = await fetchTradeinItemsCount();
    this.setCount(count)
  }

  async setBubbleCount() {
    this.bubble.innerText = this.count;
  }

  async setCount(n) {
    if (!n && n != 0) return;
    this.count = n;
    this.setAttribute('count', n);
  }

  async setBubbleVisibility() {
    if (this.count == 0) {
      this.bubble.classList.add('hidden')
    } else {
      this.bubble.classList.remove('hidden')
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this.setBubbleCount();
    this.setBubbleVisibility();
  }

  connectedCallback() {
    this.fetchItemsCount();
    this.setBubbleCount();
    this.setBubbleVisibility();
  }
}

customElements.define('trade-in-cart-icon-bubble', TradeInCartIconBubble);